// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"AppToolbar_toolbar__A5us1"};